<template>
  <div>
    <div class="main-content">
      <div class="row">
        <!-- <div class="col-md-3" id="usuarios">
          <router-link to="/users" style="color: #82868b">
            <b-card no-body>
              <b-card-body class="pb-0">
                <b-avatar class="mb-1" :variant="`light-success`" size="45">
                  <feather-icon size="21" :icon="'UsersIcon'" />
                </b-avatar>
                <div class="truncate mb-2">
                  <h2 class="mb-25 font-weight-bolder">
                    {{ dashboard.highlights.users }}
                  </h2>
                  <span>Usuários Cadastrados</span>
                </div>
              </b-card-body>
            </b-card>
          </router-link>
        </div> -->
        <div class="col-md-3" id="veiculos">
          <router-link to="/veiculos" style="color: #82868b">
            <b-card no-body>
              <b-card-body class="pb-0">
                <b-avatar class="mb-1" :variant="`light-primary`" size="45">
                  <i class="fas fa-car" style="font-size: 21px"></i>
                </b-avatar>
                <div class="truncate mb-2">
                  <h2 class="mb-25 font-weight-bolder">
                    {{ dashboard.highlights.veiculos_sem_rota }}
                  </h2>
                  <span>Veículos Sem Rota Atrelada</span>
                </div>
              </b-card-body>
            </b-card>
          </router-link>
        </div>
        <div class="col-md-3" id="quantidadeMaterias">
          <router-link to="/materiais" style="color: #82868b">
            <b-card no-body>
              <b-card-body class="pb-0">
                <b-avatar class="mb-1" :variant="`light-success`" size="45">
                  <i class="fas fa-box" style="font-size: 21px"></i>
                </b-avatar>
                <div class="truncate mb-2">
                  <h2 class="mb-25 font-weight-bolder">
                    {{ dashboard.highlights.qtd_materiais }}
                  </h2>
                  <span>Quantidade de Materiais</span>
                </div>
              </b-card-body>
            </b-card>
          </router-link>
        </div>
        <div class="col-md-3" id="quantidadeMaterias">
          <router-link to="/materiais" style="color: #82868b">
            <b-card no-body>
              <b-card-body class="pb-0">
                <b-avatar class="mb-1" :variant="`light-warning`" size="45">
                  <i class="fas fa-box" style="font-size: 21px"></i>
                </b-avatar>
                <div class="truncate mb-2">
                  <h2 class="mb-25 font-weight-bolder">
                    {{ dashboard.highlights.qtd_materiais_dispensaveis }}
                  </h2>
                  <span>Quantidade de Materiais Dispensaveis</span>
                </div>
              </b-card-body>
            </b-card>
          </router-link>
        </div>
        <div class="col-md-3" id="quantidadeUnidades">
          <router-link to="/unidades" style="color: #82868b">
            <b-card no-body>
              <b-card-body class="pb-0">
                <b-avatar class="mb-1" :variant="`light-secondary`" size="45">
                  <i class="fas fa-ambulance" style="font-size: 21px"></i>
                </b-avatar>
                <div class="truncate mb-2">
                  <h2 class="mb-25 font-weight-bolder">
                    {{ dashboard.highlights.qtd_unidades }}
                  </h2>
                  <span>Quantidade de Unidades</span>
                </div>
              </b-card-body>
            </b-card>
          </router-link>
        </div>
        <div class="col-md-3" id="quantidadeRotas">
          <router-link to="/rotas" style="color: #82868b">
            <b-card no-body>
              <b-card-body class="pb-0">
                <b-avatar class="mb-1" :variant="`light-primary`" size="45">
                  <i class="fas fa-route" style="font-size: 21px"></i>
                </b-avatar>
                <div class="truncate mb-2">
                  <h2 class="mb-25 font-weight-bolder">
                    {{ dashboard.highlights.qtd_rotas }}
                  </h2>
                  <span>Quantidade de Rotas</span>
                </div>
              </b-card-body>
            </b-card>
          </router-link>
        </div>
        <!-- <div class="col-md-3" id="quantidadeGrupos">
          <router-link to="/grupos" style="color: #82868b">
            <b-card no-body>
              <b-card-body class="pb-0">
                <b-avatar class="mb-1" :variant="`light-primary`" size="45">
                  <i class="fas fa-users" style="font-size: 21px"></i>
                </b-avatar>
                <div class="truncate mb-2">
                  <h2 class="mb-25 font-weight-bolder">
                    {{ dashboard.highlights.qtd_grupos }}
                  </h2>
                  <span>Quantidade de Grupos</span>
                </div>
              </b-card-body>
            </b-card>
          </router-link>
        </div> -->
        <!-- <div class="col-md-3" id="quantidadeSubGrupos">
          <router-link to="/sub_grupos" style="color: #82868b">
            <b-card no-body>
              <b-card-body class="pb-0">
                <b-avatar class="mb-1" :variant="`light-primary`" size="45">
                  <i class="fas fa-layer-group" style="font-size: 21px"></i>
                </b-avatar>
                <div class="truncate mb-2">
                  <h2 class="mb-25 font-weight-bolder">
                    {{ dashboard.highlights.qtd_subGrupos }}
                  </h2>
                  <span>Quantidade de SubGrupos</span>
                </div>
              </b-card-body>
            </b-card>
          </router-link>
        </div> -->
        <!-- <div class="col-md-3" id="quantidadeFamilias">
          <router-link to="/familias" style="color: #82868b">
            <b-card no-body>
              <b-card-body class="pb-0">
                <b-avatar class="mb-1" :variant="`light-primary`" size="45">
                  <i
                    class="fas fa-chalkboard-teacher"
                    style="font-size: 21px"
                  ></i>
                </b-avatar>
                <div class="truncate mb-2">
                  <h2 class="mb-25 font-weight-bolder">
                    {{ dashboard.highlights.qtd_familias }}
                  </h2>
                  <span>Quantidade de Familias</span>
                </div>
              </b-card-body>
            </b-card>
          </router-link>
        </div> -->
        <div class="col-md-3" id="quantidadePedidos">
          <router-link to="/pedidos" style="color: #82868b">
            <b-card no-body>
              <b-card-body class="pb-0">
                <b-avatar class="mb-1" :variant="`light-primary`" size="45">
                  <i class="fas fa-border-style" style="font-size: 21px"></i>
                </b-avatar>
                <div class="truncate mb-2">
                  <h2 class="mb-25 font-weight-bolder">
                    {{ dashboard.highlights.qtd_pedidos }}
                  </h2>
                  <span>Quantidade de Pedidos</span>
                </div>
              </b-card-body>
            </b-card>
          </router-link>
        </div>
        <div class="col-md-3" id="pedidosSolicitados">
          <router-link to="/pedidos" style="color: #82868b">
            <b-card no-body>
              <b-card-body class="pb-0">
                <b-avatar class="mb-1" :variant="`light-info`" size="45">
                  <i class="fas fa-paper-plane" style="font-size: 21px"></i>
                </b-avatar>
                <div class="truncate mb-2">
                  <h2 class="mb-25 font-weight-bolder">
                    {{ dashboard.highlights.pedidos_solicitados || 0 }}
                  </h2>
                  <span>Pedidos Solicitados</span>
                </div>
              </b-card-body>
            </b-card>
          </router-link>
        </div>
        <div class="col-md-3" id="pedidosAutorizados">
          <router-link to="/pedidos" style="color: #82868b">
            <b-card no-body>
              <b-card-body class="pb-0">
                <b-avatar class="mb-1" :variant="`light-warning`" size="45">
                  <i class="fas fa-check-circle" style="font-size: 21px"></i>
                </b-avatar>
                <div class="truncate mb-2">
                  <h2 class="mb-25 font-weight-bolder">
                    {{ dashboard.highlights.pedidos_autorizados || 0 }}
                  </h2>
                  <span>Pedidos Autorizados</span>
                </div>
              </b-card-body>
            </b-card>
          </router-link>
        </div>
        <div class="col-md-3" id="pedidosAprovados">
          <router-link to="/pedidos" style="color: #82868b">
            <b-card no-body>
              <b-card-body class="pb-0">
                <b-avatar class="mb-1" :variant="`light-success`" size="45">
                  <i class="fas fa-thumbs-up" style="font-size: 21px"></i>
                </b-avatar>
                <div class="truncate mb-2">
                  <h2 class="mb-25 font-weight-bolder">
                    {{ dashboard.highlights.pedidos_aprovados || 0 }}
                  </h2>
                  <span>Pedidos Aprovados</span>
                </div>
              </b-card-body>
            </b-card>
          </router-link>
        </div>
        <div class="col-md-3" id="pedidosEmSeparacao">
          <router-link to="/pedidos" style="color: #82868b">
            <b-card no-body>
              <b-card-body class="pb-0">
                <b-avatar class="mb-1" :variant="`light-primary`" size="45">
                  <i class="fas fa-boxes" style="font-size: 21px"></i>
                </b-avatar>
                <div class="truncate mb-2">
                  <h2 class="mb-25 font-weight-bolder">
                    {{ dashboard.highlights.pedidos_em_separacao || 0 }}
                  </h2>
                  <span>Pedidos Em Separação</span>
                </div>
              </b-card-body>
            </b-card>
          </router-link>
        </div>
        <div class="col-md-3" id="pedidosAguardandoRetirada">
          <router-link to="/pedidos" style="color: #82868b">
            <b-card no-body>
              <b-card-body class="pb-0">
                <b-avatar class="mb-1" :variant="`light-secondary`" size="45">
                  <i class="fas fa-clock" style="font-size: 21px"></i>
                </b-avatar>
                <div class="truncate mb-2">
                  <h2 class="mb-25 font-weight-bolder">
                    {{ dashboard.highlights.pedidos_aguardando_retirada || 0 }}
                  </h2>
                  <span>Pedidos Aguardando Retirada</span>
                </div>
              </b-card-body>
            </b-card>
          </router-link>
        </div>
        <div class="col-md-3" id="pedidosEmTransporte">
          <router-link to="/pedidos" style="color: #82868b">
            <b-card no-body>
              <b-card-body class="pb-0">
                <b-avatar class="mb-1" :variant="`light-warning`" size="45">
                  <i class="fas fa-truck" style="font-size: 21px"></i>
                </b-avatar>
                <div class="truncate mb-2">
                  <h2 class="mb-25 font-weight-bolder">
                    {{ dashboard.highlights.pedidos_em_transporte || 0 }}
                  </h2>
                  <span>Pedidos Em Transporte</span>
                </div>
              </b-card-body>
            </b-card>
          </router-link>
        </div>
        <div class="col-md-3" id="pedidosEntregues">
          <router-link to="/pedidos" style="color: #82868b">
            <b-card no-body>
              <b-card-body class="pb-0">
                <b-avatar class="mb-1" :variant="`light-success`" size="45">
                  <i class="fas fa-shipping-fast" style="font-size: 21px"></i>
                </b-avatar>
                <div class="truncate mb-2">
                  <h2 class="mb-25 font-weight-bolder">
                    {{ dashboard.highlights.pedidos_entregues || 0 }}
                  </h2>
                  <span>Pedidos Entregues</span>
                </div>
              </b-card-body>
            </b-card>
          </router-link>
        </div>
        <div class="col-md-3" id="pedidosRecebidos">
          <router-link to="/pedidos" style="color: #82868b">
            <b-card no-body>
              <b-card-body class="pb-0">
                <b-avatar class="mb-1" :variant="`light-success`" size="45">
                  <i class="fas fa-check-double" style="font-size: 21px"></i>
                </b-avatar>
                <div class="truncate mb-2">
                  <h2 class="mb-25 font-weight-bolder">
                    {{ dashboard.highlights.pedidos_recebidos || 0 }}
                  </h2>
                  <span>Pedidos Recebidos</span>
                </div>
              </b-card-body>
            </b-card>
          </router-link>
        </div>
        <div class="col-md-3" id="pedidosRecebidosParcial">
          <router-link to="/pedidos" style="color: #82868b">
            <b-card no-body>
              <b-card-body class="pb-0">
                <b-avatar class="mb-1" :variant="`light-warning`" size="45">
                  <i class="fas fa-check" style="font-size: 21px"></i>
                </b-avatar>
                <div class="truncate mb-2">
                  <h2 class="mb-25 font-weight-bolder">
                    {{ dashboard.highlights.pedidos_recebidos_parcial || 0 }}
                  </h2>
                  <span>Pedidos Recebidos Parcial</span>
                </div>
              </b-card-body>
            </b-card>
          </router-link>
        </div>
        <div class="col-md-3" id="pedidosBaixaEstoque">
          <router-link to="/pedidos" style="color: #82868b">
            <b-card no-body>
              <b-card-body class="pb-0">
                <b-avatar class="mb-1" :variant="`light-danger`" size="45">
                  <i class="fas fa-warehouse" style="font-size: 21px"></i>
                </b-avatar>
                <div class="truncate mb-2">
                  <h2 class="mb-25 font-weight-bolder">
                    {{ dashboard.highlights.pedidos_baixa_estoque || 0 }}
                  </h2>
                  <span>Pedidos Baixa de Estoque</span>
                </div>
              </b-card-body>
            </b-card>
          </router-link>
        </div>


      </div>
    </div>
  </div>
</template>

<script>
import { BCardText, BLink } from "bootstrap-vue";

import { BCard, BCardBody, BAvatar } from "bootstrap-vue";

export default {
  data() {
    return {
      dashboard: {
        highlights: {
          users: 0,
        },
      },
      cruds: [],
      user: {},
    };
  },
  components: {
    BCard,
    BCardText,
    BLink,
    BCard,
    BCardBody,
    BAvatar,
  },
  methods: {
    getDashboard() {
      const self = this;
      const api = self.$store.state.api + "dashboard";

      axios
        .post(api)
        .then((response) => {
          self.dashboard = response.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted() {
    const self = this;

    self.getDashboard();

    self.user = self.$store.state.user;

    // Check if user was redirected due to access denied
    if (self.$route.query.access_denied === 'cadastros') {
      self.$message(
        'Acesso Negado',
        'Você não possui permissão para acessar a área de Cadastros. Apenas Administradores podem acessar essa seção.',
        'error'
      );
      // Remove the query parameter from URL without reloading
      self.$router.replace({ name: 'home' });
    } else if (self.$route.query.access_denied === 'movimentar') {
      self.$message(
        'Acesso Negado',
        'Você não possui permissão para acessar a área de Movimentação. Apenas Administradores e Farmacêuticos podem acessar essa seção.',
        'error'
      );
      // Remove the query parameter from URL without reloading
      self.$router.replace({ name: 'home' });
    } else if (self.$route.query.access_denied === 'pedido_criar') {
      self.$message(
        'Acesso Negado',
        'Você não possui permissão para criar ou editar pedidos. Como Auxiliar de Farmácia, você pode apenas visualizar os pedidos existentes.',
        'error'
      );
      // Remove the query parameter from URL without reloading
      self.$router.replace({ name: 'home' });
    } else if (self.$route.query.access_denied === 'supervisor_pedido') {
      self.$message(
        'Acesso Negado',
        'Como Supervisor de Enfermagem, você pode criar apenas Pedidos SOS e Suplementares.',
        'error'
      );
      // Remove the query parameter from URL without reloading
      self.$router.replace({ name: 'home' });
    } else if (self.$route.query.access_denied === 'baixa_estoque') {
      self.$message(
        'Acesso Negado',
        'Você não possui permissão para acessar a área de Pedidos Baixa Estoque.',
        'error'
      );
      // Remove the query parameter from URL without reloading
      self.$router.replace({ name: 'home' });
    }
  },
  created() { },
};
</script>

<style>
.card-home:hover {
  box-shadow: 3px 3px #ddd;
  transform: scale(1.05);
}
</style>
